export default (klass) => class GlucoseIndicatorMixin extends klass {

  static targets = [
    ...super.targets,
    'hoursSinceLastMeal',
    'glucoseIndicator',
    'glucoseIndicatorInput'
  ]

  connect() {
    super.connect()
    this.calculateGlucoseIndicator()
  }

  calculateGlucoseIndicator() {
    if (this.hasHoursSinceLastMealTarget) {
      const hoursSinceLastMeal = this.hoursSinceLastMealTarget.value
      const hoursSinceLastMealInt = parseInt(hoursSinceLastMeal, 10)

      if (Number.isNaN(hoursSinceLastMealInt)) {
        this.setGlucoseIndicator('-')
      } else if (hoursSinceLastMealInt > 7) {
        this.setGlucoseIndicator('Fasting')
      } else {
        this.setGlucoseIndicator('Non-fasting')
      }
    }
  }

  setGlucoseIndicator(value) {
    if (this.hasGlucoseIndicatorTarget) {
      this.glucoseIndicatorTarget.textContent = value
    }

    if (this.hasGlucoseIndicatorInputTarget) {
      this.glucoseIndicatorInputTarget.value = (value === '-' ? '' : value)
    }
  }

}
